/*
 * @Description: 退货单
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  退货单: 'rerun Oder',
  退货总金额: 'Total amount returned',
  请先选择客户: 'Please select the customer first!',
  只能选择一个负责人: 'You can only choose one person in charge!',
  只能选择一种币种: 'Only one currency can be selected!',
  至少添加一条明细: 'Add at least one detail!',
  请完善明细行: 'Please complete the detail line!',
  添加明细: 'Add details',
  请输入销售订单编号: 'Please enter the sales order number',
  销售订单产品: 'Sales order product',
  请输入订单产品编号: 'Please enter the order product number',
  暂无此退货单查看权限: 'You do not have permission to view this return order'
};
